/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import i18n from '@/i18n'
import { getLatestTaxRateNames } from '@/model/dataLayer/api/cashbook/cashbook'

const entity = {
  usageName: {
    displayName: 'name'
  },
  lrMarkDisplay: {
    displayName: 'inOrOut'
  },
  typeCodeDisplay: {
    displayName: 'Typ'
  },
  accountA: {
    displayName: async () => {
      return (parseFloat((await getLatestTaxRateNames()).find(it => it.name === 'A').rateValue) * 100).toFixed(0) + '%'
    }
  },
  accountB: {
    displayName: async () => {
      return (parseFloat((await getLatestTaxRateNames()).find(it => it.name === 'B').rateValue) * 100).toFixed(0) + '%'
    }
  },
  accountC: {
    displayName: async () => {
      return (parseFloat((await getLatestTaxRateNames()).find(it => it.name === 'C').rateValue) * 100).toFixed(0) + '%'
    }
  }
}

const config = {
  load: async function (filter) {
    return (await hillo.post('Complex.php?op=getCashAccountUsage', {})).content.map(it => {
      it.lrMarkDisplay = it.lrMark.toString() === '1' ? i18n.t('deposit') : i18n.t('withdraw')
      it.typeCodeDisplay = i18n.t(it.typeCode)
      return it
    })
  },
  add: async function (item) {
    return (await hillo.post('Complex.php?op=addCashAccountUsage', {
      usage: JSON.stringify(item)
    }))
  },
  edit: async function (item) {
    console.log(item, 'item')
    return (await hillo.post('Complex.php?op=updateCashAccountUsage', {
      usage: JSON.stringify(item),
      id: item.id
    })).content
  },
  remove: async function (id) {
    return (await hillo.post('Complex.php?op=deleteCashAccountUsage', {
      id
    })).content
  }
}
export default IKDataEntity.ModelFactory(entity, config)
